import { render, staticRenderFns } from "./ShoppinglistItems.vue?vue&type=template&id=4e7f97fa&"
import script from "./ShoppinglistItems.vue?vue&type=script&lang=js&"
export * from "./ShoppinglistItems.vue?vue&type=script&lang=js&"
import style0 from "./ShoppinglistItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports